import request from "@/hooks/useRequest";

// 修改防钓鱼码
export const postUpdateAntiPhishingCodeApi = (body) => {
  return request("/web-wallet/api/v1/account/user/custom-identifier/update", {
    body,
  });
};
